import { Box, FormControl, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import { FC } from 'react';
import {
	INTEGRATIONS_PLATFORMS,
	INTEGRATIONS_PLATFORMS_IMG,
	INTEGRATIONS_PLATFORMS_IMG_TEXT,
	INTEGRATIONS_PLATFORMS_NAMES,
	IntegrationsPlatform,
} from 'redux/reducers/integrations/constants';
import { useSelector } from 'react-redux';
import { getIntegrations, getSpecialSchemes } from 'redux/reducers/settings/selectors';
import { getVatReports } from 'redux/reducers/reports/selectors';
import { TStep1Props } from './types';

export const Step1: FC<TStep1Props> = ({ platform, handlePlatformChange }) => {
	const integrations = useSelector(getIntegrations)?.integrations;
	const registrationInformation = useSelector(getSpecialSchemes);
	const vatRegistrations = useSelector(getVatReports);
	return (
		<FormControl>
			<RadioGroup
				value={platform}
				onChange={(e) => handlePlatformChange(e.target.value as IntegrationsPlatform)}
			>
				{INTEGRATIONS_PLATFORMS.map((item) => {
					if (
						item === IntegrationsPlatform.HMRC &&
						(integrations?.findIndex(
							(integration) => integration.platform === (IntegrationsPlatform.HMRC as string),
						) !== -1 ||
							vatRegistrations?.emData?.registeredCountryCode === 'GB' ||
							// registrationInformation?.findIndex((i) => i.country === 'United Kingdom') === -1 ||
							registrationInformation?.findIndex(
								(i) => i.scheme_number !== 'EAS project VAT number used',
							) === -1)
					)
						return null;
					return (
						<FormControlLabel
							key={item}
							value={item}
							control={<Radio />}
							label={
								<Box
									sx={{
										display: 'flex',
										flexDirection: 'row',
										alignItems: 'center',
										gap: '6px',
									}}
								>
									<img
										src={INTEGRATIONS_PLATFORMS_IMG[item]}
										alt={INTEGRATIONS_PLATFORMS_NAMES[item]}
										style={{
											height: '35px',
										}}
									/>
									<Typography
										style={{
											fontSize: '1.2rem',
											fontWeight: 550,
										}}
									>
										{INTEGRATIONS_PLATFORMS_IMG_TEXT[item]}
									</Typography>
								</Box>
							}
							sx={{ m: 1.5 }}
						/>
					);
				})}
			</RadioGroup>
		</FormControl>
	);
};
